var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaoChu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5BFC\u51FA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7701\\u5385\\u540E\\u53F0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8\\u4F5C\\u54C1\\u7BA1\\u7406-\\u5BA1\\u6838\\u5217\\u8868",
    transform: "translate(-1619, -181)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(1584, 165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u51FA",
    transform: "translate(35, 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60164062,13.7053906 L14.3627031,13.7053906 C14.8884062,13.6826875 15.3192918,13.9464062 15.3188594,14.4332031 L15.3188594,14.5155469 C15.3349687,15.0438906 14.8988594,15.3167969 14.3627031,15.2956094 L1.60164062,15.2956094 C0.964546875,15.2956094 0.679734375,15.0972812 0.64540625,14.5364375 L0.64540625,14.4540937 C0.66928125,13.88825 1.00725,13.6861719 1.60165625,13.7053906 L1.60164062,13.7053906 Z M14.6704219,5.29978125 L9.56801562,0.88625 C9.47976771,0.814130482 9.35794738,0.799095137 9.2548125,0.84759375 C9.15168614,0.896038686 9.08549354,0.999346532 9.08457812,1.11328125 L9.08457812,3.59540625 C9.08223437,3.74759375 8.96321875,3.85621875 8.81445312,3.8885625 C2.44890625,5.272625 1.4365625,10.5319062 1.40309561,12.4269062 C1.40070312,12.5647187 1.49751562,12.6845 1.6315625,12.716 C1.76566053,12.7474974 1.90376804,12.6823651 1.96476562,12.5588594 C3.27996875,9.84873437 5.32207812,6.95025 8.77465625,7.23589062 C8.8555625,7.24257812 8.93471875,7.26317187 8.993125,7.31960937 C9.05165212,7.37602625 9.08467361,7.45384931 9.08457812,7.53514062 L9.08457812,9.95884375 C9.08429221,10.0733444 9.15003885,10.1777505 9.25342187,10.2269687 C9.3567887,10.2762749 9.47932643,10.261504 9.56801562,10.1890469 L14.6704219,5.749375 C14.7350829,5.69255817 14.7721719,5.61065484 14.7721719,5.52457812 C14.7721719,5.43848437 14.7350625,5.35654687 14.6704219,5.29976562 L14.6704219,5.29978125 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaoChu);
export default __webpack_public_path__ + "static/media/daoChu.58eb5f60ec75b6d87438a1a7657a9059.svg";
export { ForwardRef as ReactComponent };